import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, GenerateCsv } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";

replaceInChain(chain, GenerateCsv, async props => {
    if (!props.dataForUnparse) {
        return;
    }

    const { unparse } = await import(/* webpackChunkName: "papaparse" */ "papaparse");
    const csv = unparse(props.dataForUnparse);
    const csvBlob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });

    const fileName = `solveindustrial-list_${props.parameter.wishListId}.csv`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(csvBlob);
    downloadLink.setAttribute("download", fileName);
    downloadLink.click();
})